export const DIAGNOSTIC_ROUTE_PARAM_ALLOWLIST = new Set([
  'id',
  'menuObjectType',
  'cartIdEditing',
  'offerId',
  'rewardId',
  'rewardBenefitId',
  'benefitId',
  'rbiOrderId',
  'step',
  'slotKey',
  'pickerAspectKey',
]);

export const DIAGNOSTIC_VARIANT_ALLOWLIST = [
  'menuImplementation',
  'effectiveCartImplementation',
  'experimentCartImplementation',
  'cartRecoveryOverride',
  'checkoutV2',
  'modifierRedesign',
  'offersRewardsImplementation',
] as const;

export const DIAGNOSTIC_PRICING_CORRELATION_ALLOWLIST = [
  'checkoutRepriceRequestId',
  'requestId',
  'correlationId',
] as const;
